export const CURRENT_YEAR = new Date().getFullYear()
export const EARLIEST_EXPORT_YEAR = 2000

export const normalizeExportYear = (value: string) => value.replace(/\D/g, '').slice(0, 4)

export const normalizeExportMonth = (value: string) => value.replace(/\D/g, '').slice(0, 2)

export const isValidExportPeriod = (year: string, month: string) => {
    const numericYear = Number(year)
    const numericMonth = Number(month)

    return (
        /^\d{4}$/.test(year) &&
        numericYear >= EARLIEST_EXPORT_YEAR &&
        numericYear <= CURRENT_YEAR &&
        /^\d{1,2}$/.test(month) &&
        numericMonth >= 1 &&
        numericMonth <= 12
    )
}
